import {Routes} from '@angular/router';
import {CheckoutComponent} from './checkout/checkout.component';
import {OrderComponent} from './order/order.component';

export const orderRoutesUnprotected: Routes = [
  {path: 'order', component: OrderComponent, data: {blankHeader: true}},
  {path: 'bestellung', component: OrderComponent, data: {blankHeader: true}},
  {path: 'checkout', component: CheckoutComponent, data: {blankHeader: true}},
];
